"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgrammaticPlaybackProofDto = void 0;
const class_validator_1 = require("class-validator");
class ProgrammaticPlaybackProofDto {
    kind;
    displayId;
    proofId;
    programmaticDeliveryId;
    mediaId;
    instanceId;
    occurrenceId;
    playerProtocolVersion;
    authorizationId;
    mediaCampaignId;
    date;
    visualizations;
}
exports.ProgrammaticPlaybackProofDto = ProgrammaticPlaybackProofDto;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Equals)("programmatic"),
    __metadata("design:type", String)
], ProgrammaticPlaybackProofDto.prototype, "kind", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], ProgrammaticPlaybackProofDto.prototype, "displayId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], ProgrammaticPlaybackProofDto.prototype, "proofId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], ProgrammaticPlaybackProofDto.prototype, "programmaticDeliveryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], ProgrammaticPlaybackProofDto.prototype, "mediaId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], ProgrammaticPlaybackProofDto.prototype, "instanceId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.MaxLength)(300),
    __metadata("design:type", String)
], ProgrammaticPlaybackProofDto.prototype, "occurrenceId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(2),
    (0, class_validator_1.Max)(2),
    __metadata("design:type", Number)
], ProgrammaticPlaybackProofDto.prototype, "playerProtocolVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], ProgrammaticPlaybackProofDto.prototype, "authorizationId", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], ProgrammaticPlaybackProofDto.prototype, "mediaCampaignId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsISO8601)(),
    __metadata("design:type", String)
], ProgrammaticPlaybackProofDto.prototype, "date", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(1),
    __metadata("design:type", Number)
], ProgrammaticPlaybackProofDto.prototype, "visualizations", void 0);
